import {  ObserverService } from '@DavisDigital/davisdigitalfrontend.module';

export class ApiService {

	public permissions; 

	private baseUrl = '/?slatAction=';
	//@ngInject
	constructor(
		private $q				: ng.IQService,
		private $http			: ng.IHttpService,
		private $window			: ng.IWindowService,
		private $timeout		: ng.ITimeoutService,
		private $cacheFactory	: ng.ICacheFactoryService,
		private observerService : ObserverService
	) {
		observerService.attach(this.handleUnauthorized, 'Unauthorized');
		observerService.attach(this.handleAuthorized, 'loginSuccess');
	}

	public getPermissions = () =>{
		return this.permissions;
	}

	public getPermissionsPromise = () =>{
		var deferred = this.$q.defer<ng.IHttpPromiseCallbackArg<any>>();
		
		this.request('davisdigital:api.getPermissions',{})
			.catch(()=>{
				deferred.reject();
			})
			.finally(()=>{
				deferred.resolve(this.permissions)
			})
		
		return deferred.promise;
	}
	
	public getTypesByParent = (parentTypeSystemCode:string): ng.IPromise<any> => {
		
		let deferred = this.$q.defer();
		
		var data = {
			parentTypeSystemCode: parentTypeSystemCode
		}

		this.request('davisdigital:api.getChildTypesByParent', data).then( result => {
			deferred.resolve( result.data.data );
		}).catch( result => {
			deferred.reject( result );
		});

		return deferred.promise;
	}

	public handleAuthorized = () =>{
		var redirectIndex = this.$window.location.href.indexOf('redirectTo=');
		console.log('handleAuthorized',redirectIndex, redirectIndex > -1);
		if(redirectIndex > -1){
			var redirectTarget = this.$window.location.href.substring(redirectIndex + 11, this.$window.location.href.length);
			redirectTarget.replace('#','');
			console.log('got target', redirectTarget, '/' + decodeURIComponent(redirectTarget))
			this.$window.location.href = '/' + decodeURIComponent(redirectTarget);
		}
	}

	public handleUnauthorized = () =>{
		var currentLocation = this.$window.location.href;
		
		//Don't redirect if book detail is accessed via token
		if( currentLocation.indexOf("sharedToken") !== -1 && currentLocation.indexOf("book") !== -1 && currentLocation.indexOf("bookID") !== -1) {
			console.log("not redirecting for shared page...");
			return;
		}

		let locations = currentLocation.split('/');
		locations.splice(0, 3);//remove http://www.davis.com
		currentLocation = locations.join('/');

		this.$window.location.href = '/my-profile?redirectTo=' + currentLocation;
	}

	public getEndpoint = (slatAction: string) =>{
		return this.baseUrl + slatAction;
	}

	public request = ( slatAction: string, data?: any, method?: string, cacheRequest=false ): ng.IPromise<ng.IHttpPromiseCallbackArg<any>> => {
		var deferred = this.$q.defer<ng.IHttpPromiseCallbackArg<any>>();

		// Set the method if it's undefined
		if ( 'undefined' === typeof data ) {
			method = ( 'undefined' === typeof method ) ? 'GET' : method;
			data = {}
		} else {
			method = ( 'undefined' === typeof method ) ? 'POST' : method;
		}

		var endpoint = this.getEndpoint(slatAction);

		if(!cacheRequest){
			var httpCache = this.$cacheFactory.get('$http');
			httpCache.remove(endpoint);
		}

		var config = {
			url: endpoint,
			method: method,
			data: {
				apiData: data,
				requestPermissions: this.permissions == null
			}
		}


		this.$http( config ).then( (response:any) => {
			
			if(response.data.redirectTarget){
				
				var target = response.data.redirectTarget + '/';
				
				if(this.$window.location.href.split('/').length > 3){ 
					target += this.$window.location.href.split('/')[3]
				}
				
				deferred.resolve( response )
				this.$window.location.href = target;
				return;
			}
			
			if(response.data.permissions != null){
				this.permissions = response.data.permissions;
				this.observerService.notify('permissions', this.permissions);
			}
			
			deferred.resolve( response );
		}).catch( (response) => {
			deferred.reject( response );
		});

		return deferred.promise;
	}
	
	public getAllSsoList = (): ng.IPromise<any> => {
		
		let deferred = this.$q.defer();

		this.request('davisdigital:api.ssoLoginData').then( result => {
			deferred.resolve( result.data.data );
		}).catch( result => {
			deferred.reject( result );
		});

		return deferred.promise;
	}

}